module.exports = __webpack_public_path__ + "static/media/grid.4cda2f3b.png";